import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';

function CustomDataGrid(props) {
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 5,

  });

  const [rowCountState, setRowCountState] = React.useState(props.dataRows.length);
  const { page, pageSize } = paginationModel;
  const startRowIndex = page * pageSize;
  const endRowIndex = (page + 1) * pageSize;
  const rows = props.dataRows.slice(startRowIndex, endRowIndex);
  const onRowsSelectionHandler = (ids) => {
    const selectedRowsData = ids.map((id) => rows.find((row) => row.id === id));
    console.log(selectedRowsData);
    props.getselectedData(selectedRowsData);
  };
  const selection = (props) => {
    // console.log("props.row.approvalStatusDescription: " + props.row.approvalStatusDescription);
    // if (props.row.approvalStatusDescription == 'Approved' || props.row.approvalStatusDescription == 'Canceled') {
    //   return false;
    // }
    return true
  };

  console.log(props.selectedRows)
  return (
    <div style={{ height: 400, width: '100%', }}>

      <DataGrid
        rows={props.dataRows}
        columns={props.columns}
        // rowCount={rowCountState}
        // paginationModel={paginationModel}
        // paginationMode="server"
        // onPaginationModelChange={setPaginationModel}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 5,
            },
          },
        }}
        pageSizeOptions={[5]}
        checkboxSelection
        disableRowSelectionOnClick
        onRowSelectionModelChange={(ids) => props.getselectedData(ids)}
        rowSelectionModel={props.selectedRows}
        isRowSelectable={(params) => selection(params)}
        loading={props.isLoading}
        getRowHeight={() => 50}
      />
    </div>
  );
}

export default CustomDataGrid;
